import {KeyStorage} from './Storage';

const STORAGE_KEY = 'eszu'; // eazyshow user
type StorageDataType = {
    sessionId: string;
}
export const UserDataStorage = new KeyStorage<StorageDataType>(STORAGE_KEY, {base64: true});
